/* SKNBODY: presentation timing for Shopify's native customer privacy banner. */
(function () {
  'use strict';

  var root = document.documentElement;
  var delayMs = 1500;
  var releaseTimer;

  function releaseBanner() {
    window.clearTimeout(releaseTimer);

    releaseTimer = window.setTimeout(function () {
      root.classList.remove('skn-cookie-delay-pending');
    }, delayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', releaseBanner, { once: true });
  } else {
    releaseBanner();
  }
})();
